import { render, staticRenderFns } from "./UserFeedbackPopUp.vue?vue&type=template&id=2d47e6e6&scoped=true&"
import script from "./UserFeedbackPopUp.vue?vue&type=script&lang=js&"
export * from "./UserFeedbackPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UserFeedbackPopUp.vue?vue&type=style&index=0&id=2d47e6e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47e6e6",
  null
  
)

export default component.exports